<h2 mat-dialog-title>{{ editMode ? 'Edit' : 'Add' }} Out of State Training Program</h2>

<mat-dialog-content>
  <form [formGroup]="trainingForm">
    <div class="flex flex-col gap-4">

      <mat-form-field>
        <mat-label>Out of State Authorized Training Program Name </mat-label>
        <input matInput formControlName="trainingProgramName" placeholder="Enter Out of State Authorized Training Program Name" maxlength="100">
        <mat-error *ngIf="trainingForm.get('trainingProgramName').hasError('required')">
          Out of State Authorized Training Program Name is required
        </mat-error>
      </mat-form-field>

      <mat-form-field>
        <mat-label>State of Licensure/Authorization </mat-label>
        <mat-select formControlName="state" required>
          <mat-option *ngFor="let state of sharedService.allowedStates" [value]="state">
            {{ state }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="trainingForm.get('state').hasError('required')">
          State of Licensure/Authorization is required
        </mat-error>
      </mat-form-field>

      <mat-form-field>
        <mat-label>License/Authorization #</mat-label>
        <input matInput formControlName="licenseNumber" placeholder="Enter license/authorization number" maxlength="100">
        <mat-error *ngIf="trainingForm.get('licenseNumber').hasError('required')">
          License/Authorization # is required
        </mat-error>
      </mat-form-field>

    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" type="button" [disabled]="!trainingForm.valid" (click)="onSave()">Save</button>
</mat-dialog-actions>